module.exports = __webpack_public_path__ + "static/img/display_lcd_azul_16x2_i2c-1.3abf5a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/display_lcd_azul_16x2_i2c-1.svg
// module id = Us+m
// module chunks = 0